export const SLIDER_VALUES = {
  MARKS: [0, 100],
};
